<template>
	<section class="page">
		<Editor :id="editorId" v-model="myValue" :init="init"></Editor>
	</section>
</template>

<script>
import tinymce from "tinymce/tinymce";
import "tinymce/themes/modern/theme";
import Editor from "@tinymce/tinymce-vue";
import "tinymce/plugins/image";
import "tinymce/plugins/link";
import "tinymce/plugins/code";
import "tinymce/plugins/lists";
import "tinymce/plugins/colorpicker";
import "tinymce/plugins/textcolor";
import { now } from "@/basics/utils.js";
export default {
	data() {
		return {
			tinymceHtml: "",
			id: "",
			init: {
				language_url: "/tinymce/langs/zh_CN.js",
				language: "zh_CN",
				skin_url: "/tinymce/skins/lightgray",
				height: 300,
				plugins: "link lists image code colorpicker  ",
				toolbar:
					"bold underline strikethrough  | forecolor backcolor | bullist numlist |  undo redo | link unlink image | removeformat",
				branding: false,
			},
		};
	},
	props: {
		recordModel: {
			type: String,
			default: "",
		},
		dataModelName: {
			type: String,
			default: "",
		},
		value: {
			type: String,
			default: "",
		},
		fieldInfo: Object,
		recordId: {
			type: String,
			default: "",
		},
	},
	computed: {
		editorId: function() {
			return this.recordModel + "-" + this.fieldInfo.name + "-" + now();
		},
		myValue: {
			get: function() {
				return this.value;
			},
			set: function(newValue) {
				this.$emit("input", newValue);
				this.$emit("change", newValue);
			},
		},
	},
	created() {},
	mounted() {
		tinymce.init({});
	},
	methods: {},
	watch: {},
	components: {
		Editor,
	},
};
</script>
<style lang="scss" scoped>
</style>
